/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_S4Inputs */

const en_tut_akses_s4 = /** @type {(inputs: Tut_Akses_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you are the one trying to get in: open the **Permintaan masuk ruang** panel, choose the room, press **Minta akses**, and wait for the room owner to press **Terima**.`)
};

const id_tut_akses_s4 = /** @type {(inputs: Tut_Akses_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau Anda yang ingin masuk ruang tertutup: buka panel **Permintaan masuk ruang**, pilih ruang tujuan, tekan **Minta akses**, dan tunggu pemilik ruang menekan **Terima**.`)
};

/**
* | output |
* | --- |
* | "If you are the one trying to get in: open the **Permintaan masuk ruang** panel, choose the room, press **Minta akses**, and wait for the room owner to press ..." |
*
* @param {Tut_Akses_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_s4 = /** @type {((inputs?: Tut_Akses_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_s4(inputs)
	return en_tut_akses_s4(inputs)
});